import { create } from 'zustand';

interface TiebreakerStore {
	tiebreakerRef: HTMLDivElement | null;
	setTiebreakerRef: (ref: HTMLDivElement | null) => void;
	scrollToTiebreaker: () => void;
}

export const useTiebreakerStore = create<TiebreakerStore>((set, get) => ({
	tiebreakerRef: null,
	setTiebreakerRef: (ref) => set({ tiebreakerRef: ref }),
	scrollToTiebreaker: () => {
		const ref = get().tiebreakerRef;
		ref?.scrollIntoView({ behavior: 'smooth' });
	}
}));
